import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4289e9f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 mb-4 center" }, "Login", -1))
const _hoisted_3 = { class: "loginContainer" }
const _hoisted_4 = { class: "loginBox" }
const _hoisted_5 = { class: "layout gutter--xl" }
const _hoisted_6 = { class: "row justify--center mt-2" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "row justify--center mt-2" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "row justify--center mt-2" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_13 = { class: "row justify--center mt-2" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "loginLoginAssistent" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "center display-6" }, "Ny adgangskode", -1))
const _hoisted_17 = { class: "row justify--center" }
const _hoisted_18 = { class: "flex md12" }
const _hoisted_19 = { class: "row justify--center" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Reset adgangskode")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Annuller")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_LoadingButton = _resolveComponent("LoadingButton")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_it_modal = _resolveComponent("it-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_va_input, {
                  class: "loginInput",
                  label: "Brugernavn",
                  type: "text",
                  modelValue: _ctx.userName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName) = $event)),
                  bordered: "",
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.login()), ["enter"]))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_va_input, {
                  class: "loginInput",
                  label: "Adgangskode",
                  type: "password",
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.login()), ["enter"])),
                  modelValue: _ctx.userPassword,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userPassword) = $event)),
                  bordered: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.loadingStatus)
                  ? (_openBlock(), _createBlock(_component_LoadingButton, {
                      key: 0,
                      color: 'success'
                    }))
                  : (_openBlock(), _createBlock(_component_va_button, {
                      key: 1,
                      color: "success",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.login()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("ul", _hoisted_15, [
                  _createElementVNode("li", null, [
                    _createElementVNode("p", {
                      class: "routerAssistant",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.forgottenPasswordModal = !_ctx.forgottenPasswordModal))
                    }, "Glemt din adgangskode?")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.forgottenPasswordModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.forgottenPasswordModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_16
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.emailString,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.emailString) = $event)),
              class: "emailInput",
              label: "Din emailadresse",
              type: "email"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_va_button, {
              class: "mr-2",
              color: "success",
              gradient: "",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.newPasswordRequest()))
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-2",
              color: "secondary",
              gradient: "",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.forgottenPasswordModal = !_ctx.forgottenPasswordModal))
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}